<script>
export default {

}
</script>

<style lang="scss">
.sp {

  #wrapper {
    transition: all .2s ease;
    position: relative;
    left: 0;
    &:after {
      content: '';
      visibility: hidden;
      opacity: 0;
      transition: opacity .2s ease;
    }
  }
  #header {
    position: relative;
    z-index: 1;
    height: 64px;
    opacity: 1;
    transition: all .2s;
  }
  #main {
    position: relative;
    z-index: 2;
  }

  #menu {
    transition: all .2s ease;
    left: 100%;
  }
  #menu-left {
    transition: all .2s ease;
    left: -80%;
  }
  #bg-image {
    position: fixed;
    z-index: -1;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
  }

  // header
  // wljp.cssの.headerとバッティングしないようにheader.headerにする。
  header.header {
    background-color: rgba(#000,.1);
    display: flex;
    align-items: center;
    height: $sp-header-height;
    width: 100%;
    position: relative;
    .tip {
      position: absolute;
      z-index: 1;
      right: -12px;
      top: 48px;
      background-color: rgba(#005BAC,.8);
      border-radius: 4px;
      padding: 8px 20px;
      &:before {
        content: '';
        position: absolute;
        top: -20px;
        left: 50%;
        transform: translate3d(-50%,0,0);
        display: block;
        width: 25px;
        height: 22px;
        border-bottom: 11px solid #005BAC;
        border-top: 11px solid transparent;
        border-right: 11px solid transparent;
        border-left: 11px solid transparent;
      }
    }
  }
  .header {
    &-back {
      width: 64px;
      height: 100%;
      border-right: 1px solid rgba(#000,.16);
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        color: #fff;
      }
    }
    &-title {
      padding-left: 24px;
      h1 {
        font-size: 2.0rem;
        font-weight: bold;
        color: #fff;
      }
    }
    &-search {
      width: calc(100% - 86px);
      display: flex;
      align-items: center;
      &-title {
        text-align: center;
        padding: 0 20px;
        white-space: nowrap;
      }
      &-input {
        display: inline-block;
        width: 100%;
        max-width: 612px;
        .formparts.search {
          input[type="text"] {
            height: 48px;
            width: 100%;
            color: #fff;
            &::placeholder {
              color: $color-line;
            }
            &:focus {
              outline: 0;
            }
          }
          .icn {
            color: #fff;
          }
        }
      }
      &-button {
        .button {
          background-color: #005BAC;
          border-radius: 4px;
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 36px;
          width: 100%;
          transition: all .1s ease-out;
          &:hover {
            opacity: .7;
          }
          .icn {
            margin-right: 8px;
          }
        }
      }
      &-link {
        margin-left: 20px;
        white-space: nowrap;
        &-text {
          display: inline-block;
          @include hoverOpacity();
          & + .header-search-link-text {
            margin-left: 20px;
          }
        }
      }
      &-config {
        display: inline-block;
        white-space: nowrap;
        margin-left: 20px;
        &-item {
          display: inline-block;
        }
        .list
        a {text-decoration: none;}
        a,.formparts label {
          @include hoverOpacity();
          &:hover {
            color: inherit;
          }
        }
      }
      &-arrow {
        margin-left: 20px;
        .icon {
          cursor: pointer;
          @include hoverOpacity();
        }
      }
      &-tab {
        &-item {
          height: 68px;
          display: inline-flex;
          align-items: center;
          position: relative;
          font-size: 2.0rem;
          .text {
            padding: 4px 20px;
            border-right: 1px solid rgba(#fff,.2);
          }
          &:not(.is-active) {
            @include hoverOpacity();
          }
          &.is-active {
            .text {
              color: $color-yellow;
            }
            &:after {
              content: '';
              position: absolute;
              left: 0;
              bottom: 0;
              height: 3px;
              width: 100%;
              background-color: $color-yellow;
            }
          }
        }
      }
      &-select {
        margin-left: 20px;
        .formparts.select {
          margin-bottom: 0;
          width: 258px;
          .select-label {
            color: #fff;
            height: 40px;
            &.is-selected {
              background-color: rgba(#000,.1);
            }
          }
          .select-option {
            color: #000;
            li {
              height: 40px;
            }
          }
        }
      }
    }
    &-label {
      position: absolute;
      right: 0;
      width: 86px;
      height: 68px;
      background-color: rgba(#005BAC,.1);
      display: flex;
      align-items: center;
      justify-content: center;
      &.is-active {
        background-color: $color-yellow;
      }
      @include hoverOpacity();
    }
    &-bookmark {
      position: absolute;
      right: 0;
      width: 72px;
      height: 74px;
      border-left: 1px solid rgba(0,0,0,.1);
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all .2s ease;
      .icn {
        color: #fff;
      }
      &.is-active {
        background-color: $color-link;
        .icn {
          color: #fff;
        }
      }
    }
  }

  // main
  .main {
    background-color: #fff;
    border-top-right-radius: 8px;
    &-heading {
      &-row {
        display: flex;
        align-items: center;
        border-bottom: 1px solid $color-line;
        position: relative;
      }
      &-result {
        font-size: 1.4rem;
        padding: 20px;
        &-num {
          color: $color-content;
          font-weight: bold;
        }
        &-link {
          color: $color-link;
          margin-left: 10px;
        }
        &-current {
          color: $color-content;
          font-weight: bold;
        }
      }
      &-menu {
        &-item {
          padding: 20px;
          & + .main-heading-menu-item {
            border-left: 1px solid $color-line;
          }
        }
        &-link {
          color: $color-link !important;
          position: relative;
          font-size: 1.4rem;
          .icn {
            position: absolute;
            right: 0;
            top: 50%;
            transform: translate3d(0,-50%,0);
            // &.up {
            //   display: none;
            // }
          }
        }
      }
      &-delete {
        color: $color-link;
        text-align: right;
      }
    }
    &-container {
      overflow-y: auto;
      padding-bottom: 85px;
    }
  }

  .menu-btn {
    position: fixed;
    z-index: $index-menu-btn;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    transition: transform .2s ease;
    &-1,&-2 {
      background-color: $color-link;
      width: 82px;
      height: 72px;
      bottom: 0;
      position: relative;
      .icn {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%,-50%,0);
        color: #fff;
      }
    }
    &-1 {
      border-top-left-radius: 8px;
      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        background-color: rgba(255,255,255,.1);
        display: block;
        width: 100%;
        height: 100%;
      }
      .icn {
        font-size: 2.0rem;
      }
    }
    &-2 {
    }
  }
  .navi-btn {
    position: fixed;
    z-index: $index-menu-btn;
    bottom: 12px;
    left: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    // transition: all .2s ease;
    background-color: #fff;
    border-radius: 50%;
    box-shadow: 0 5px 20px rgba(0,0,0,.16);
    .icn {
      color: $color-link;
    }
  }
  .menu-left {
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: $index-menu;
    width: 80%;
    padding: 0 20px;
    transition: all .2s ease;
    &-list {
      width: calc(100% - 40px);
      position: absolute;
      left: 20px;
      bottom: 80px;
      list-style: none;
      &-item {
        border-top: 1px solid rgba(255,255,255,.2);
        &-label {
          color: #fff;
          font-size: 1.6rem;
          display: block;
          padding: 20px 0;
        }
      }
    }
    &-close {
      position: absolute;
      left: 20px;
      bottom: 20px;
      .icn-wrap {
        position: relative;
        display: block;
        width: 48px;
        height: 48px;
        color: #fff;
        border: 1px solid #fff;
        border-radius: 50%;
        .icn {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate3d(-50%,-50%,0);
        }
      }
    }
  }

  .popup-wrapper {
    position: fixed;
    z-index: $index-popup;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    &:before {
      content: '';
      display: block;
      width: 100%;
      height: 100%;
      position: fixed;
      top: 0;
      left: 0;
      background-color: rgba(0,0,0,.2);
      backdrop-filter: blur(3px);
    }
    .popup-container:not(.loading) {
      position: absolute;
      top: 20%;
      left: 0;
      bottom: 0;
      .popup {
        position: relative;
        padding-bottom: 100px;
      }
    }
    .popup-container.loading {
      position: absolute;
      top: 50%;
      right: 50%;
      transform: translate3d(50%,-50%,0);
      box-shadow: 0 5px 20px rgba(#000,.16);
      text-align: center;
    }

    .popup-action {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: #{$index-popup + 1};
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      box-shadow: 0 -5px 20px rgba(0,0,0,.16);
      // 二重でポップアップを表示する場合に、１番目のポップアップを背面に隠すために設定
      &.hide-parent-popup {
        z-index: -1000;
      }
      // 右下に閉じるボタンのみを表示する場合に設定
      &.corner {
        width: 95px;
        height: 78px;
        border-top-left-radius: 8px;
        left: auto;
        right: 0;
      }
      .button-submit {
        width: calc(100% - 93px);
        padding: 14px 0 14px 40px;
        .btn.is-inactive {
          color: $color-inactive;
          pointer-events: none;
        }
      }
      .button-close {
        width: 93px;
        .btn {
          border: 0;
          min-width: auto;
          background-color: transparent;
          .icn {
            color: $color-sup;
          }
        }
      }
    }
  }

  // headerが非表示の場合
  .is-hidden-header {
    #header {
      // transform: translate3d(0,-120px,0);
      height: 16px;
      opacity: 0;
    }
  }
  .is-visible-menu {
    #wrapper {
      left: -100%;
    }
    #navi-btn,
    #menu-btn {
      visibility: hidden;
      opacity: 0;
    }
    #menu {
      left: 0;
      .menu-close {
        visibility: visible;
        opacity: 1;
      }
    }
  }
  .is-visible-menu-left {
    overflow: hidden;
    #wrapper {
      left: 80%;
    }
    #menu-btn,
    #navi-btn {
      visibility: hidden;
      opacity: 0;
    }
    #menu-left {
      left: 0;
    }
  }
  .is-focused-input {
    #wrapper {
      position: relative;
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        z-index: 3;
        display: block;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.6);
        opacity: 1;
        visibility: visible;
      }
      .search-settings {
        top: 50%;
        bottom: auto;
        padding: 0;
        height: auto;
        background-color: transparent;
        transform: none;
        .formparts.function {
          margin: 20px 20px 0!important;
        }
      }
      #menu-btn,
      #navi-btn,
      #navi-2-btn {
        display: none;
      }
    }
  }
  @media print {
    .is-preview-print {
      #wrapper,
      #bg-image {
        display: none;
      }
    }
  }
}
</style>
